<h1>Mis Cursos</h1>
<h5 *ngIf="email">Inicio sesion con {{email}}</h5>
<div class="container" *ngIf="arry; else loading">
  <mat-card *ngFor="let misCursos of arry" class="card">
    <mat-card-header>
        <mat-card-title>{{misCursos.titulo}}</mat-card-title>
    </mat-card-header>      
    <button mat-button (click)="irACurso(misCursos.id)" id="boton">Ir al Curso</button>  
</mat-card>
</div>
 


  <ng-template #loading>
  <h1>No tenes Cursos!</h1>
</ng-template>